<template>
  <vk-modal :has-close-icon="closeIcon" @close="$emit('close')">
    <vk-modal-body class="MODAL">
      <vk-modal-header :class="['bd-b-gray30', {closeIcon: 'p-l-6'}]">
        <span class="">Filter</span>
      </vk-modal-header>
      <vk-modal-content>
        <div class="CONTENT">
          <div id="FILTERS">
            <div class="m-t-1">
              <div class="LABEL text-bold p-b-1 text-md c-gray90">Overall Ratings</div>
              <div class="OVERALL-RATINGS">
                <div
                    v-for="n in [null,1,2,3,4,5]"
                    :key="`rating-${n}`"
                    to="#"
                    :selenium="`page-link:${n}`"
                    class="RATING-RADIOS"
                    :class="{ 'FIRST': !n, 'LAST': n === 5 }"
                >
                  <div
                    class="LABEL text-sm">{{ ratingTitle(n) }}
                  </div>
                  <div class="radio RADIO">
                    <input
                        type="radio"
                        :id="`rating-${n}`"
                        :value="n"
                        name="rating"
                        class="m-r-1"
                        :checked="n === dataObj.rating"
                        v-model="dataObj.rating">
                    <label :for="`rating-${n}`">&nbsp;</label>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="LABEL text-bold m-t-1 p-y-2 text-md c-gray90">Areas of Expertise</div>
              <div class="PRO-OCCUPATION">
                <div
                    class="OCCUPATIONS"
                    v-for="(occ, index) in [ showAllPlaceHolder, ...occupations ]"
                    :key="'occ-'+index"
                    :class="{'FIRST': index === 0, 'LAST': index === occupations.length }">
                  <div
                      class="LABEL text-sm"
                      :class="{GRAYED : !displayOccupation(occ.display_name) && occ.id}">
                    {{ occ.display_name }}
                    <span v-if="occ.id">
                      ({{ displayOccupation(occ.display_name)}})
                    </span>
                  </div>
                  <div class="radio RADIO">
                    <input
                        type="radio"
                        :id="'occ-'+index"
                        :value="occ.id "
                        name="occupation"
                        :checked="occ.id === dataObj.occupation_id"
                        :disabled="!displayOccupation(occ.display_name) && occ.id"
                        v-model="dataObj.occupation_id">
                    <label :for="'occ-'+index">&nbsp;</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-center ai-center bd-t-gray30">
        <div class="BUTTONS w-100">
          <button @click="reset()" class="BUTTON bg-white">
            Clear All
          </button>
          <button @click="submit(dataObj)" class="BUTTON">
            Apply
          </button>
        </div>
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderMenuChevron from '@/layouts/components/HeaderMenuChevron';
import { keys } from '@/constants/reviewSortKeys';

export default {
  SORTKEYS: keys,
  name: 'view-review-modal',
  provide () {
    return {
      $menu: this.$data,
    };
  },
  components: {
    HeaderMenuChevron,
  },
  props: {
    closeIcon: {
      type: Boolean,
      default: true,
    },
    initFilter: {
      type: Object,
      default: () => {},
    },
    occupationsName: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
    dataObj: {
      occupation_id: null,
      sorting: 'created_dtm desc',
      rating: null,
    },

  }),
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
    ]),
    occupations () {
      return Object.values(
        this.serviceProviderCatalogOccupations
      ).map(oc => (oc.occupation), []) || [];
    },
    showAllPlaceHolder () {
      return { id: null,
        display_name: `${'Show All'
      + ' ('}${this.occupationsName.total})` };
    },
  },
  watch: {
    initFilter: {
      immediate: true,
      handler (val) {
        this.init(val);
      },
    },
  },
  methods: {
    ratingTitle (val) {
      switch (true) {
        case (val === 1):
          return `${val} star`;
        case (val > 1):
          return `${val} stars`;
        default:
          return 'All';
      }
    },
    toggleSortBy () {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        setTimeout(() => {
          const container = this.$el.querySelector('#SORT-BY');
          container.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    },
    submit (data) {
      const [occupation] = this.occupations.filter(oc => (oc.id === data.occupation_id));
      this.$emit('filter', {
        data,
        occupation_name: occupation ? occupation.display_name : null,
      });
    },
    reset () {
      this.dataObj.occupation_id = null;
      this.dataObj.sorting = 'created_dtm desc';
      this.dataObj.rating = null;
      this.submit(this.dataObj);
    },
    init (data) {
      if (data && Object.keys(data).length) {
        Object.keys(data).forEach((d) => {
          this.dataObj[d] = data[d];
        });
      }
    },
    displayOccupation (val) {
      const occupations = this.occupationsName.aggregation.review_count_by_occupation;
      return occupations[val] ? occupations[val] : 0;
    },
  },
};
</script>
<style lang="scss" scoped>
 @import "~@homeservices/design-kit/tools";

  $border: 1px solid $color-gray40;
  .MODAL {
    @include desktop {
      position: absolute;
      top: 119px;
      right: 0px;
      height: 100%;
      padding-bottom: $unit;
    }
    @include tablet {
      max-width: 400px;
    }
    border: 2px $color-gray50 solid;
    background-color: white;
  }
  .CONTENT {
    background-color: white;
    padding: 0;
  }
  #FILTERS {
    padding:  0 $unit * 2;
    margin: auto;
  }
  .OVERALL-RATINGS {
    @include text-medium;
    display: flex;
    flex-direction: column;
    align-items: left;
    outline: none;
    .RATING-RADIOS {
      justify-content: start;
      border-left-style: none;
      text-decoration: none;
      padding: 8px 0px !important;
      background-color: #FFFFFF;
      .LABEL, .RADIO {
        display: inline-block;
      }
      .RADIO {
        float: left;
      }
    }
    .ACTIVE {
      background-color: $color_depot;
      color: #FFFFFF;
      outline: none;
      border-color: $color_depot;
    }
    .FIRST {
      border-radius: 5px 0 0 5px;
    }
    .LAST {
      border-radius: 0 5px 5px 0;
    }
  }
  .PRO-OCCUPATION {
    .OCCUPATIONS {
      padding: 8px 0px 8px 0px;
      background-color: #FFFFFF;
      .LABEL, .RADIO {
        display: inline-block;
      }
      .RADIO {
        float: left;
      }
    }
  }
  .SORTBY {
    cursor: pointer;
    .LABEL, .ICON {
      display: inline-block;
    }
    .ICON {
      float: right;
    }
  }
  .BUTTONS {
    display: flex;
    justify-content: end;
    padding-bottom: $unit;
    .BUTTON {
      margin: $unit;
      padding: $unit $unit * 2;
      border-radius: 2px;
      border: solid 1px $color-gray50;
    }
  }
  .FOOTER {
    background-color: white;
  }
  .GRAYED {
    color:$color-gray40;
  }
</style>
